module.exports = __webpack_public_path__ + "static/media/module_keycloak.1a8ec7a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/modules/module_keycloak.jpg
// module id = ./src/resources/images/modules/module_keycloak.jpg
// module chunks = 0